<template lang="pug">
    m-list(v-bind="$attrs" v-on="$listeners" class="m-list-effectiveness-accordion-questions")
        template(#template="{item, index}")
            m-card-effectiveness-accordion-question(
                @click="$emit('click:item', {item:item, index:index})"
                @click:option-question="$emit('click:option-item', {...$event, optionKey: index})"
                @keyup.enter="$emit('click:item', {item:item, index:index})"
                @keyup.enter.option-question="$emit('click:option-item', {...$event, optionKey: index})"

                :item="item"
                :answers="answers"
                :index="index"
                :section-key="sectionKey"
                :key="`${index}-${item.title}`")
</template>

<script>
    import MList from "@modules/lists/m-list";
    import MCardEffectivenessAccordionQuestion from "@modules/cards/concrete/m-card-effectiveness-accordion-question";
    export default {
        name: "m-list-effectiveness-accordion-questions",
        components: {MCardEffectivenessAccordionQuestion, MList},
        props: {
          sectionKey: {
              type: Number
          },
          answers: {
              type: Array
          }
        }
    }
</script>

<style scoped lang="scss">
  .m-list-effectiveness-accordion-questions {
    padding-top: 0.5rem;
    margin-bottom: 0 !important;
    margin-top: 0 !important;
  }
  .m-card-effectiveness-accordion-question {

      &:focus {
          border-bottom: 2px solid var(--v-primary-base);
          outline: none;
      }
  }
</style>
